<template>
  <div class="home-container" ref="homeContainer">
    <div class="home-projects__wrapper" ref="homeMainBody" @click="onJump" style="cursor:pointer">
      <div class="home__curtain">
        <div class="curtain__item up" @transitionend="curtainAniEnded"></div>
        <div class="curtain__item down"></div>
      </div>
      <div class="index-hero-container">
        <div class="index-hero__slideshow-container jsCollection">
          <div class="slideshow__item jsItem" v-for="(slide, index) in slides" :key="index">
            <div class="bg">
              <img class="bg_img" :src="$bowser.mobile ? slide.src.mobile : slide.src.pc" alt="" />
            </div>
            <div class="content">
              <p class="slide__name jsTextFx" v-html="slide.name"></p>
              <div class="slide__line-text">
                <!-- <p class="slide__category jsTextFx">类型</p> -->
              </div>
            </div>
          </div>
        </div>
        <div class="index-hero-directions">
          <div class="prev"></div>
          <div class="next"></div>
        </div>
        <div class="index-hero-pagination">
          <template v-if="$bowser.mobile">
            <div class="pagination__item-container">
              <div class="item__child render">
                <p>{{ currentIndex | fillzero }}/</p>
                <p>{{ slides.length | fillzero }}</p>
              </div>
              <div class="item__child mask">
                <p>{{ currentIndex | fillzero }}/</p>
                <p>{{ slides.length | fillzero }}</p>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="pagination__item" v-for="(slide, index) in slides" :key="index">
              <i class="item__line"></i>
              <p class="item__text">0{{ index + 1 }}</p>
            </div>
          </template>
        </div>
      </div>
    </div>
    <opening :loading="initing && firstEnterWebSite" @openAniFinish="onOpenAniFinish"></opening>
  </div>
</template>

<script>
import 'swiper/css/swiper.css';
import { mapMutations, mapState } from 'vuex';
import { sliderShow } from '@/utils/base';
import { slides } from '@/utils/data';
import opening from './_opening.vue';

export default {
  name: 'home',
  components: {
    opening,
  },
  data() {
    return {
      slides: [],
      currentTitle: '',
      initing: true,
      requesting: false,
      currentIndex: 0,
      currentUrl: '',
    };
  },
  computed: {
    ...mapState(['firstEnterWebSite']),
  },
  watch: {
    currentIndex(val) {
      this.currentUrl = this.slides[val - 1].link;
    },
  },
  mounted() {
    console.log('mounted');
  },
  destroyed() {},
  beforeRouteEnter(to, from, next) {
    slides('home').then((res) => {
      next((vm) => {
        vm.setData(res);
      });
    });
  },

  beforeRouteUpdate(to, from, next) {
    console.log(to, from, next);
  },
  filters: {
    fillzero(index) {
      return index < 10 ? `0${index}` : index;
    },
  },
  methods: {
    ...mapMutations(['SIGN_ENTERED']),
    formatNumber(number) {
      return Number(number) <= 10 ? `0${number}` : number;
    },
    onOpenAniFinish() {
      const that = this;
      that.$refs.homeMainBody.classList.add('--opening');
      if (!that.firstEnterWebSite) {
        that.$refs.homeMainBody.classList.add('--ani-ended');
      }
      that.$nextTick(() => {
        sliderShow.init((index) => {
          that.currentIndex = index + 1;
        });
      });
    },
    curtainAniEnded() {
      const that = this;
      that.$refs.homeMainBody.classList.add('--ani-ended');
      that.SIGN_ENTERED();
    },
    getImgs() {
      const that = this;
      return new Promise((resolve, reject) => {
        that.$request
          .get('/api/imgs/home')
          .then((res) => {
            const { data } = res;
            if (data.length > 0) {
              const imgs = data.map((item) => (that.$bowser.mobile ? item.src.mobile : item.src.pc));
              that.preload(imgs, 'src').then(() => {
                resolve();
              });
              that.slides = data;
            } else {
              reject(new Error('没有数据'));
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    setData(data) {
      const that = this;
      that.slides = data;
      that.currentIndex = 1;
      if (!that.firstEnterWebSite) {
        that.onOpenAniFinish();
      } else {
        that.getImgs().then(() => {
          that.initing = false;
        });
      }
      that.$nextTick(() => {
        if (that.$bowser.mobile) {
          that.$refs.homeContainer.style.cssText = `height:${that.$screenHeight}px;`;
        }
      });
    },
    onJump() {
      if (this.currentUrl) {
        window.location.href = this.currentUrl;
      }
    },
  },
};
</script>

<style></style>
